<template>
    <div>
        <div class="order-details-container">
            <div class="order-details-title text-center">
                <h3><strong v-html="thankYouMessage"></strong></h3>
                <div v-html="experienceMessage"></div>
            </div>
            <div class="location-info">
                <div class="row">
                    <div class="d-none d-md-flex col-md-7">
                        <div class="map-container" v-if="$store.state.cart.curbsideFulfillmentMode === 'pickup' && $store.state.cart.store">
                            <a title="Directions to this store" v-bind:href="'https://www.google.com/maps/dir/?api=1&amp;destination=' + addressConcatted" target="_blank">
                                <img alt="Street map of this store" v-bind:src="'https://maps.googleapis.com/maps/api/staticmap?center=' + latLon + '&amp;zoom=15&amp;size=327x192&amp;scale=2&amp;markers=anchor:center|icon:https://images.heb.com/is/image/HEBGrocery/map-marker-h-1x?$article$|'+ latLon + '&amp;key=' + gMapsKey">
                            </a>
                        </div>
                    </div>
                    <div class="col-12" :class="{'col-md-5' : $store.state.cart.curbsideFulfillmentMode == 'pickup'}">
                        <div class="order-details" :class="{'order-details__delivery' : $store.state.cart.curbsideFulfillmentMode == 'delivery'}">
                            <div class="order-method-type">
                                <div v-if="$store.state.cart.curbsideFulfillmentMode == 'pickup'">Curbside Pickup</div>
                                <div v-if="$store.state.cart.curbsideFulfillmentMode === 'delivery'">Delivery</div>

                                <div class="order-time">
                                    {{ $store.state.cart.timeslot.startTime | formatDate }},
                                    {{ $store.state.cart.timeslot.startTime | formatTime }} &#8209;
                                    {{ $store.state.cart.timeslot.endTime | formatTime }}
                                </div>
                            </div>
                            <div class="order-location">
                                <!-- Content to show for curbside order pickup -->
                                <div v-if="$store.state.cart.curbsideFulfillmentMode == 'pickup'">
                                    <strong>{{ $store.state.cart.store.name }}</strong>
                                    <div>
                                        {{ $store.state.cart.store.address1 }}
                                    </div>
                                    <div>
                                        {{ $store.state.cart.store.city }},
                                        {{ $store.state.cart.store.state }}
                                        {{ $store.state.cart.store.postalCode }}
                                    </div>
                                    <a v-if="$store.state.cart.store" class="system-link" v-bind:href="'https://www.google.com/maps/dir/?api=1&destination=' + addressConcatted" target="_blank">
                                        <span class="icon-direction">
                                            <img src="/img/directions-solid.svg">
                                        </span>
                                        Get directions
                                    </a>
                                </div>
                                <!-- End content to show for curbside order pickup -->

                                <!-- Content to show for delivery -->
                                <div v-if="$store.state.cart.curbsideFulfillmentMode === 'delivery'">
                                    <strong v-if="deliveryAddress.nickname">{{ deliveryAddress.nickname }}</strong>
                                    <div>
                                        {{ deliveryAddress.address1 }}
                                    </div>
                                    <div v-if="deliveryAddress.address2">
                                        {{ deliveryAddress.address2 }}
                                    </div>
                                    <div>
                                        {{ deliveryAddress.city }}, {{ deliveryAddress.state }} {{ deliveryAddress.postalCode }}
                                    </div>
                                </div>
                                <!-- end Content to show for delivery -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-disclaimer">
                <p v-html="nextStepsMessage"></p>
                <a href="/static-pages/faq"><strong>{{ readFaqs }}</strong> <span class="fa fa-caret-right text-primary"></span></a>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'OrderDetails',
  props: {
    thankYouMessage: String,
    experienceMessage: String,
    experienceType: String,
    nextStepsMessage: String,
    readFaqs: String,
    deliveryLocation: String
  },
  data () {
    return {

    }
  },
  computed: {
    gMapsKey(){
        return _.get(window, 'heb.data.general.googleMapsAPIKey', '')
    },
    addressConcatted: function () {
      var concat = (`${this.$store.state.cart.store.address1} ${this.$store.state.cart.store.city} ${this.$store.state.cart.store.state} ${this.$store.state.cart.store.postalCode}`)
      return encodeURIComponent(concat)
    },
    latLon: function () {
      return this.$store.state.cart.store.latitude + ',' + this.$store.state.cart.store.longitude
    },
    deliveryAddress () {
      var curbsideShippingGroup = this.$store.state.cart.shippingGroups.find(function (group) {
        return group.shippingMethod === 'curbsideShippingGroup'
      })
      return curbsideShippingGroup.address
    }
  },
  filters: {
    formatDate (date) {
      return date ? moment(String(date)).parseZone().format('MMM D, YYYY') : ''
    },
    formatTime (time) {
      return time ? moment(String(time)).parseZone().format('h:mmA') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/lib";

.order-details-container {
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
    background-color: $color-text-white;
}

.order-details-title {
    margin-bottom: 32px;
    padding-bottom: 16px;
    border-bottom: 1px solid $color-divider-light-gray;
}

.location-info {
    margin-bottom: 16px;
}

.order-method-type {
    color: $color-text-dark;
    font-size: 18px;
    font-weight: $font-weight-bold;
    line-height: 21px;
}

.order-details {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    border-bottom: 1px solid $color-divider-light-gray;
    padding-bottom: 16px;

    &__delivery {
        text-align: center;
    }
}

.order-time {
    color: $color-text-green;
    font-size: 16px;
    font-weight: $font-weight-bold;
    line-height: 22px;
    padding: 2px 0 16px;
}

.order-location {
    color: $color-text-dark;
    font-size: 14px;
    line-height: 21px;
}

.icon-direction {
    img {
        height: 15px;
    }
}

.order-disclaimer {
    font-size: 14px;
    line-height: 21px;
    text-align: left;
}

.map-container img {
    width: 100%;
    height: 180px;
}

@media screen and (min-width: $breakpoint-desktop){
    .order-details-container {
        padding: 32px 116px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
    }

    .order-details-title {
        padding: 0;
        border: none;
    }

    .order-details {
        padding: 0;
        border: none;
    }

    .order-disclaimer {
        padding: 0 50px;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
    }

    .location-info {
        margin-bottom: 32px;
    }

}
</style>

<docs>
    The Vue component for the order details.

    ```jsx

        props: {
            thankYouMessage: String,
            experienceMessage: String,
            experienceType: String,
            nextStepsMessage: String,
            readFaqs: String,
            deliveryLocation: String
        }

        <order-details v-bind="$store.state.cart.curbsideFulfillmentMode === 'pickup' ? curbsideExperience : deliveryExperience"></order-details>

    ```

    The v-bind on order details component is checking to see if user experience is curbside or delivery. Depending on what the user experience is, this will show specific content related to the users experience.

</docs>
